import React, { Component } from "react";
import PropTypes from "prop-types";
import Layout from "../Layout";
import { Layout5 } from "../ContentBox";
import { DivHover, DivHelp } from "./styled";

class DividerView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false
    };
  }
  onHover = () => {
    this.setState({ hover: true });
  };
  onMouseOver = () => {
    this.setState({ hover: false });
  };
  render() {
    return (
      <DivHover
        onMouseLeave={this.onMouseOver.bind(this)}
        onMouseEnter={this.onHover.bind(this)}
      >
        <Layout {...this.props} type="DividerView" />
        {this.state.hover && <DivHelp>Content</DivHelp>}
      </DivHover>
    );
  }
}

DividerView.propTypes = {
  childOf: PropTypes.string,
  values: PropTypes.object,
  cell: PropTypes.array,
  layout: PropTypes.func
};
DividerView.defaultProps = {
  childOf: "Content",
  values: {
    parent: "Content",
    type: "DividerView",
    containerPadding: "0px",
    line: "solid",
    lineColor: "rgba(255,255,255,1)",
    alignValue: "center",
    width: "100%",
    size: "1px"
  },
  layout: Layout5
};
export default DividerView;



// WEBPACK FOOTER //
// ./src/editor/layout/components/Content/DividerView.js